import { render, staticRenderFns } from "./TranslationTabs.vue?vue&type=template&id=7f51725a&scoped=true&"
import script from "./TranslationTabs.vue?vue&type=script&lang=js&"
export * from "./TranslationTabs.vue?vue&type=script&lang=js&"
import style0 from "./TranslationTabs.vue?vue&type=style&index=0&id=7f51725a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f51725a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabs})
